var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRightBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.996 17.875-1.121-1.081L12.883 11 6.875 5.206l1.121-1.081L15.125 11l-7.129 6.875Z",
  fill: "#111"
})));
export default SvgArrowRightBlack;